import { IMedia } from "config/media"
import { useInView } from "react-intersection-observer"
import * as styles from "./styles.module.scss"
import cx from "classnames"
import * as React from "react"

interface MediaItemProps {
  media: IMedia
  type: "solid" | "border"
}

const MediaItem: React.FC<MediaItemProps> = ({ media = "solid", type }) => {
  const [ref, inView, entry] = useInView({ threshold: 0 })

  return (
    <div ref={ref}>
      <div
        className={cx({
          [styles.mediaItem]: true,
          [styles[type]]: type,
          [styles.belowViewport]:
            inView && entry && entry.intersectionRect.top > 0,
        })}
      >
        <div className={styles.box}>
          <a
            className={styles.button}
            href={media.cite}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className={styles.shadow} />
            <div className={styles.background} />
            <div className={styles.logo}>
              <div className={styles.logoBox}>
                <figure className={styles.figure}>
                  <img
                    className={styles.image}
                    src={media.image}
                    alt={media.title}
                  />
                </figure>
              </div>
            </div>
            <div className={styles.content}>
              <h5 className={styles.heading}>{media.title}</h5>
              <p className={styles.date}>{media.date}</p>
              <q className={styles.quote} cite={media.cite}>
                {media.quote}
                <i
                  className={cx({
                    [styles.arrow]: true,
                    ["bsk-icon-arrow-stick-right-thicker"]: true,
                  })}
                />
              </q>
            </div>
          </a>
        </div>
      </div>
    </div>
  )
}

export default MediaItem
